import React from 'react';
import { ThemeProvider } from 'styled-components';
// import Seo from './../components/seo';
import { theme } from './../theme/theme';
import GlobalStyle from './../styles/GlobalStyles';
import Navigation from './../components/Navigation/Navigation';
import Footer from './../components/Footer/Footer';
import SimpleReactLightbox from 'simple-react-lightbox';

const Layout = ({ children, location }) => {
  return (
    <ThemeProvider theme={theme}>
      <>
        {/* <Seo title='Ambra Polska - Skandynawskie domy szkieletowe' /> */}
        <SimpleReactLightbox>
          <GlobalStyle />
          <Navigation fakeLink={location.pathname} />
          {children}
          <Footer />
        </SimpleReactLightbox>
      </>
    </ThemeProvider>
  );
};

export default Layout;
